module.exports = __webpack_public_path__ + "img/52.8bdb9e77.png";